<template>
  <!-- 综合列表 -->
  <div>
    <div v-if="loading || zhSearchDomList.some((item) => item.list.length > 0)">
      <div v-for="item in zhSearchDomList" :key="item.key">
        <ArticleCard
          v-if="item.list.length > 0"
          :title="item.title"
          @toMore="toSearchMore(item.active)"
        >
          <template #content>
            <div v-if="item.key === 'type2'">
              <BjItem
                class="bj-list-item"
                v-for="i in item.list"
                :key="i.userId"
                :headerPhoto="i.logo"
                :name="i.title"
                :unit="i.unitName"
                :research="i.researchDirection"
                @click.native="
                  $router.push({
                    path: 'appusesbaijia',
                    query: { item: 0, id: i.userId },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'type4'" class="bk-list-box">
              <BkItem
                class="bk-list-item"
                v-for="i in item.list"
                :key="i.id"
                :cover="i.logo"
                :name="i.title"
                @click.native="
                  $router.push({
                    path: 'appusesbaike',
                    query: { item: 1, id: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'type5'">
              <MlItem
                class="list-item"
                v-for="i in item.list"
                :key="i.id"
                :headerPhoto="i.logo"
                :name="i.title"
                @click.native="
                  $router.push({
                    path: 'appusesjigou',
                    query: { item: 2, id: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'articleType5'">
              <ZxItem
                class="list-item"
                v-for="i in item.list"
                :key="i.id"
                :title="i.title"
                :img="i.other.cover"
                :creatTime="i.releaseTime | dateFormat"
                :number="i.readPv"
                :author="i.periodical"
                @click.native="
                  $router.push({
                    path: 'msgDetails',
                    query: { type: 5, id: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'articleType0'">
              <LvItem
                class="list-item"
                v-for="i in item.list"
                :key="i.id"
                :type="i.type"
                :title="i.title"
                :author="i.authors[0].name"
                :otherAuthor="
                  i.authors && Array.isArray(i.authors) && i.authors.length > 1
                    ? ',...'
                    : ''
                "
                :periodicalName="i.periodical"
                :periodicalTime="
                  i.type == 1
                    ? `${i.journalsYear}年${i.journalsVolume}月${i.journalsTerm}日`
                    : `${i.journalsYear}年第${i.journalsTerm}期`
                "
                @click.native="
                  $router.push({
                    path: 'thesisDetail',
                    query: { type: 0, id: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'articleType2'">
              <ZzItem
                class="list-item"
                v-for="i in item.list"
                :key="i.id"
                :cover="i.other.cover"
                :title="i.title"
                :author="i.authors | zzAuthorsF"
                @click.native="
                  $router.push({
                    path: 'concentrationDetails',
                    query: { type: 2, id: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'articleType8'">
              <XshyItem
                class="hy-list-item"
                v-for="i in item.list"
                :key="i.id"
                :title="i.title"
                :cover="i.other.cover"
                :beginTime="
                  $global.transferDay(i.meeting.meetingBeginTime, '.')
                "
                :address="i.meeting.addr"
                @click.native="
                  toDetail(8, i.id || i.other.goodsId, i.meeting.open)
                "
              />
            </div>
            <div v-else-if="item.key === 'articleType9'" class="px-list">
              <PxItem
                class="px-list-item"
                v-for="i in item.list"
                :key="i.id"
                :title="i.title"
                :saleType="i.other.saleType"
                :cover="i.other.cover"
                :author="i.other.publisher"
                :price="
                  i.other.minPrice
                    ? [i.other.minPrice, i.other.maxPrice]
                    : [i.other.maxPrice]
                "
                :number="i.enrollment"
                @click.native="
                  $router.push({
                    path: 'courseDetails',
                    query: { type: 9, id: i.id, goodsId: i.other.goodsId },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'type6'">
              <MlItem
                class="list-item"
                v-for="i in item.list"
                :key="i.id"
                :headerPhoto="i.logo"
                :name="i.title"
                @click.native="
                  $router.push({
                    path: 'appusesinstitutions',
                    query: { type: 2, orgId: i.id },
                  })
                "
              />
            </div>
            <div v-else-if="item.key === 'goodsTypeId4'" class="report-list">
              <BgItem
                class="report-list-item"
                v-for="i in item.list"
                :key="i.id"
                :title="i.title"
                :cover="i.albumPics"
                :price="i.goodsPrice"
                :industryOne="i.industryLevelOneVal"
                :industryTwo="i.industryLevelTwoVal"
                @click.native="
                  $router.push({
                    path: '/detail/report',
                    query: { id: i.id },
                  })
                "
              />
            </div>
          </template>
        </ArticleCard>
      </div>
    </div>
    <noneList noneType="search" v-else />
  </div>
</template>

<script>
import ArticleCard from "@/views/mobileView/components/articleCard.vue";
import BjItem from "@/views/mobileView/components/listItem/bjItem.vue";
import BkItem from "@/views/mobileView/components/listItem/bkItem.vue";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import ZzItem from "@/views/mobileView/components/listItem/zzItem.vue";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import MlItem from "@/views/mobileView/components/listItem/mlItem.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Zh",
  components: {
    ArticleCard,
    BjItem,
    BkItem,
    ZxItem,
    LvItem,
    ZzItem,
    XshyItem,
    PxItem,
    MlItem,
    noneList,
    BgItem,
  },
  filters: {
    // 时间格式化
    dateFormat(o) {
      if (o) {
        const dt = new Date(Number(o));
        const m = (dt.getMonth() + 1 + "").padStart(2, "0");
        const d = (dt.getDate() + "").padStart(2, "0");
        return `${m}-${d}`;
      } else {
        return "";
      }
    },
    zzAuthorsF(arr) {
      let nameArr = arr.map((item) => item.name);
      return nameArr.join();
    },
  },
  data() {
    return {
      zhSearchDomList: [
        {
          title: "学者",
          key: "type2",
          active: "6",
          list: [],
        },
        {
          title: "期刊",
          key: "type4",
          active: "7",
          list: [],
        },
        {
          title: "机构",
          key: "type5",
          active: "8",
          list: [],
        },
        {
          title: "论文",
          key: "articleType0",
          active: "2",
          list: [],
        },
        {
          title: "资讯",
          key: "articleType5",
          active: "3",
          list: [],
        },
        {
          title: "专著",
          key: "articleType2",
          active: "4",
          list: [],
        },
        {
          title: "会议",
          key: "articleType8",
          active: "5",
          list: [],
        },
        {
          title: "课程",
          key: "articleType9",
          active: "10",
          list: [],
        },
        {
          title: "行业报告",
          key: "goodsTypeId4",
          active: "11",
          list: [],
        },
        {
          title: "名录",
          key: "type6",
          active: "9",
          list: [],
        },
      ],
      loading: false,
    };
  },
  created() {
    this.getSynthesisList();
  },
  methods: {
    async getSynthesisList() {
      this.loading = true;
      let query = {
        otherQueryParams: {
          platformId: 1,
        },
        configMap: {
          must: [{ esField: "all", queryValue: this.$route.query.paramStr }],
        },
      };
      const res = await this.$apis.searchServe.getArticleSearchList(query);
      this.zhSearchDomList.forEach((item) => {
        item.list = res.data[item.key] ? [...res.data[item.key].list] : [];
      });
      this.loading = false;
    },
    // 跳转各个文章搜索列表页
    toSearchMore(active) {
      this.$bus.$emit("changeTabs", active);
    },
    // 文章跳转详情
    toDetail(active, id, open = "") {
      console.log(active, id);
      switch (active) {
        case 5: //资讯
          this.$router.push({
            name: "msgDetails",
            query: {
              id,
              type,
            },
          });
          break;
        case 0: //论文
          this.$router.push({
            name: "thesisDetail",
            query: {
              id,
              type,
            },
          });
          break;
        case 2: //专著
          this.$router.push({
            name: "concentrationDetails",
            query: {
              id,
              type,
            },
          });
          break;
        case 8: //会议
          window.open(
            this.$global.meetingH5Url +
              `pagesModule/meetingDetails/index?type=8&id=${id}${
                open ? "&open=" + open : ""
              }`,
            "_self"
          );
          break;
        case 9: //报告
          this.$router.push({
            name: "courseDetails",
            query: {
              id,
              type,
            },
          });
          break;
        case 6: //报告
          this.$router.push({
            name: "dataDetails",
            query: {
              id,
              type,
            },
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bk-list-box {
  display: flex;
  flex-wrap: wrap;
  .bk-list-item {
    flex: none;
    margin-right: 12px;
    &:nth-child(n + 4) {
      margin-top: 15px;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.bj-list-item {
  margin-top: 21px;
}

.list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:last-child {
    border: none;
  }
}

.hy-list-item {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  &:last-child {
    margin-bottom: 0;
  }
}

.px-list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .px-list-item {
    margin-bottom: 12px;
    width: 156px;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
  }
}

.report-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .report-list-item {
    margin-bottom: 12px;
    width: 156px;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
    overflow: hidden;
  }
}
</style>
